var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.241858 16.4824C0.1646 16.5682 0.104202 16.6693 0.0641118 16.7796C0.0240212 16.89 0.00502404 17.0076 0.00820454 17.1257C0.011385 17.2438 0.0366822 17.3601 0.0826493 17.468C0.128617 17.5758 0.194355 17.6731 0.276112 17.7542C0.357868 17.8354 0.454041 17.8988 0.559139 17.9409C0.664238 17.983 0.776202 18.003 0.888642 17.9996C1.00108 17.9963 1.1118 17.9697 1.21446 17.9214C1.31712 17.8732 1.40973 17.8041 1.48699 17.7182L8.76592 9.62299C8.91624 9.45599 9 9.23488 9 9.00505C9 8.77523 8.91624 8.55412 8.76593 8.38712L1.48699 0.290967C1.41024 0.203214 1.31765 0.132352 1.21461 0.0824998C1.11157 0.0326455 1.00013 0.00479628 0.886752 0.000565773C0.773376 -0.00366664 0.66033 0.0158074 0.554181 0.0578549C0.44803 0.0999005 0.350893 0.16368 0.268408 0.245492C0.185925 0.327304 0.119739 0.425513 0.0736967 0.534419C0.0276543 0.643325 0.00267275 0.760753 0.000202722 0.879886C-0.0022673 0.999017 0.0178228 1.11748 0.0593076 1.22839C0.100792 1.33929 0.162844 1.44044 0.241859 1.52594L6.96589 9.00505L0.241858 16.4824Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f38678166da52e0d602b07fd440f38ad.svg";
export { ForwardRef as ReactComponent };